import React from "react";
import { Route } from "react-router-dom";
import CustomerMarkupScreen from "../../containers/customerMarkupScreen";

const CustomerMarkupRoutes = (props) => {
  const { access = {}, match } = props;
  let { create, read, update = false } = access;
  return (
    <>
      {
       !!read && (
        <Route
          exact
          path={match.path}
          render={(routeProps) => (
            <CustomerMarkupScreen {...routeProps} screenPermissions={access} />
          )}
        />
      )
      }
     
    </>
  );
};

export default CustomerMarkupRoutes;
